// this file is automatically generated by git.version.ts script
export const versions = {date: 1789141489680, version: '4.5.0.ccfff71', revision: 'ccfff71a3634ac39b882809adc92c680a56c2947', branch: 'release-5.25'};